import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import Header from './components/global/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; // ✅ Correct import
import Footer from './components/global/Footer';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import FloatingTiger from './components/global/FloatingTiger';
import Portfolio from './pages/Portfolio';
import ScrollToTop from './hooks/ScrollToTop';
import { useEffect } from 'react';
import Portfolio2 from './pages/Portfolio2';
import Works from './pages/Works';
import AIPlatform from './pages/AIPlatform';


function App() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <BrowserRouter>
      <ScrollToTop>
        {/* <FloatingTiger /> */}
        <div className='body-orange'></div>


        <Header />
        <Routes>
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<> <About /> </>} />
          <Route path="/services" element={<> <Services /> </>} />
          <Route path="/portfolio" element={<> <Portfolio /> </>} />
          <Route path="/portfolio-2" element={<> <Portfolio2 /> </>} />
          <Route path="/works" element={<> <Works /> </>} />
          <Route path="/ai-platform" element={<> <AIPlatform /> </>} />


          <Route path="/" element={<Home />} />

        </Routes>
        <Footer />
      </ScrollToTop>
    </BrowserRouter>
  );
}

export default App;
